import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { mq } from 'styles/mixins';

export const CarouselContainer = styled.div`
  display: flex;
  overflow: hidden;
  user-select: none;
`;

export const IndicatorsList = styled.ul`
  list-style-type: none;
  display: none;
  align-items: center;
  justify-content: center;
  ${mq.smallIp(css`
    display: flex;
  `)};
`;
